import { Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ApiService } from './api.service'
import { unwrapCrudList, type CrudListResponse } from '../common/utils/crud-response.util'

export interface ContractDoctorSpecialtyRecord {
  id: number | string
  contractDoctorId: number | string
  specialtyId: string
}

@Injectable({ providedIn: 'root' })
export class ContractDoctorSpecialtyService {
  private readonly url = 'contract-doctor-specialties'

  constructor(private api: ApiService) {}

  getByContractDoctor(
    contractDoctorId: number | string,
    options?: { cacheBust?: boolean },
  ): Observable<ContractDoctorSpecialtyRecord[]> {
    // `scope=contract` invalidates stale Redis entries that returned all doctor specialties.
    const bust = options?.cacheBust ? `&_cb=${Date.now()}` : ''
    return this.api
      .get<
        CrudListResponse<ContractDoctorSpecialtyRecord>
      >(`${this.url}?filter=contractDoctorId||$eq||${contractDoctorId}&limit=1000&scope=contract${bust}`)
      .pipe(map((res) => unwrapCrudList(res)))
  }

  create(contractDoctorId: number | string, specialtyId: string): Observable<ContractDoctorSpecialtyRecord> {
    return this.api.post<ContractDoctorSpecialtyRecord>(this.url, { contractDoctorId, specialtyId })
  }

  delete(id: number | string): Observable<void> {
    return this.api.delete<void>(`${this.url}/${id}`)
  }
}
